import { render, staticRenderFns } from "./screenshot.vue?vue&type=template&id=560766a0&"
import script from "./screenshot.vue?vue&type=script&lang=js&"
export * from "./screenshot.vue?vue&type=script&lang=js&"
import style0 from "./screenshot.vue?vue&type=style&index=0&id=560766a0&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports